import { useEffect, useRef } from 'react'

function useEffectRegularly(
  callback: () => void,
  every: number, // milliseconds
  startingAt?: Date,
) {
  const callbackRef = useRef(() => {})

  // Remember the latest callback.
  useEffect(() => {
    callbackRef.current = callback
  }, [callback])

  useEffect(() => {
    let intervalHandle: ReturnType<typeof setInterval> | undefined
    const timeoutHandle = setTimeout(
      () => {
        intervalHandle = setInterval(() => {
          callbackRef.current()
        }, every)
      },
      startingAt ? startingAt.getTime() - Date.now() : 0,
    )
    return () => {
      clearTimeout(timeoutHandle)
      if (intervalHandle !== undefined) {
        clearInterval(intervalHandle)
      }
    }
  }, [every, startingAt])
}

export default useEffectRegularly
